import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

const StatCard = ({
  icon,
  iconBgClass,
  iconColorClass,
  value,
  label,
  isLoading = false,
  isActive = false,
  onClick,
}) => {
  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault()
      onClick()
    }
  }

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      className={classNames(
        "flex cursor-pointer items-center gap-2 rounded border bg-white px-3 py-2 transition-all",
        {
          "border-blue-600 bg-blue-50": isActive,
          "border-gray-300 hover:border-blue-600 hover:shadow-base": !isActive,
        }
      )}
    >
      <div
        className={classNames(
          "flex h-6 w-6 shrink-0 items-center justify-center rounded",
          iconBgClass
        )}
      >
        <i className={classNames("fa-kit", icon, "text-sm", iconColorClass)} />
      </div>
      <span className="text-lg font-semibold text-gray-900">
        {isLoading ? (
          <span className="inline-block h-5 w-6 animate-pulse rounded bg-gray-200" />
        ) : (
          value
        )}
      </span>
      <span className="text-xs font-medium uppercase tracking-wide text-gray-500">
        {label}
      </span>
    </div>
  )
}

StatCard.propTypes = {
  icon: PropTypes.string.isRequired,
  iconBgClass: PropTypes.string.isRequired,
  iconColorClass: PropTypes.string.isRequired,
  value: PropTypes.number,
  label: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
}

export default StatCard
